import React, { useState } from "react";
import {
  Modal,
  Table
} from "react-bootstrap";
import { colors, initialAlert } from "../configs";
import { stringDateTimeReceipt } from "../Utility/dateTime";
import Modal_Alert from "./Modal_Alert";
import { formatTime, handleDigit4, nanToZero } from "../Utility/function";
import { OneButton } from "../components";
import { db } from "../db/firestore";
import { useDispatch, useSelector } from "react-redux";
import firebase from 'firebase/app';
import Modal_TwoInput from "./Modal_TwoInput";
import { updateNormalInbound } from "../redux/inboundSlice";
import Modal_Loading from "./Modal_Loading";
import { pushByTwoFilter } from "../api/onesignal";

const { dark } = colors;


const initialUpdateProduct = { id:'',name:'',prevQty:'',prevCost:'',nextQty:'',nextCost:'',importId:'',tempId:'' }

function Modal_Inbound({
  backdrop=true, // true/false/static
  animation=true,
  show,
  onHide,
  centered=true,
  size='md',
  current,
  setCurrent
  
}) {
    const { shop:{ notiImport, shopId } } = useSelector(state=>state.shop);
    const { profile:{ name:profileName } } = useSelector(state=>state.profile);
    const dispatch = useDispatch();
    const { 
        id:importId , product, dateTime, billNumber, createName, supplier:{vender_Name = '', sale_Name = '', tel = '', lineId=''}, 
  } = current;

  const [alert_Modal, setAlert_Modal] = useState(initialAlert);
  const { status, content, onClick, variant } = alert_Modal;
  const [thisProduct, setThisProduct] = useState(initialUpdateProduct);
  const { nextQty, nextCost } = thisProduct;
  const [product_Modal, setProduct_Modal] = useState(false);
  const [loading, setLoading] = useState(false);


  function openProduct(item){
    const { name, qty, cost, tempId, id } = item;
    setProduct_Modal(true)
    setThisProduct({
        ...initialUpdateProduct,
        id,
        name,
        prevQty:qty,
        prevCost:cost,
        nextQty:qty,
        nextCost:cost,
        tempId,
        importId
    })
  };
  async function submit(){
    const { nextQty, nextCost, importId, tempId:thisId, name, prevQty, prevCost, id } = thisProduct;
    setThisProduct(initialUpdateProduct)
    const newProduct = product.map(({ tempId,...rest })=>{
        return tempId===thisId
            ?{...rest,cost:nextCost,qty:nextQty}
            :{...rest}
    });
    const { totalQty, totalCost } = newProduct.reduce(
        ( acc, item )=>{
            acc.totalQty += Number(item.qty);
            acc.totalCost += Number(item.qty)*Number(item.cost);
            return acc
        },
        { totalQty:0, totalCost:0 }
    );
    setProduct_Modal(false)
    try {
        // อัปเดตสินค้า 1 รายการและ อัปเดตรายงาน
        setLoading(true)
        let stockDocs = []
        const remain = await db.runTransaction( async (transaction)=>{
            const importRef =  db.collection('importProduct').doc(importId);
            const stockRef = db.collection('stock').doc(id)
            const stockDoc = await transaction.get(stockRef);
            const { stock:productStock, cost:productCost, unit='', linkId = null, linkDetail = [] } = stockDoc.data();
            const diffTotalCost = (nextCost*nextQty)-(prevCost*prevQty);
            let diffQty = nextQty - prevQty;
            let updateStock = 0;
       
            if(linkId){
                const baseId = id
                const { linkMultiply } = linkDetail.find(a=>a.id === id)
                diffQty = diffQty * linkMultiply; // จำนวนในหน่วยที่เล็กที่สุด
                for (const { id } of linkDetail) {
                    const stockRef = db.collection("stock").doc(id);
                    stockDocs.push(transaction.get(stockRef));
                };
                for (let i = 0; i < linkDetail.length; i++) {
                    const { id } = linkDetail[i];
                    const stockDoc = await stockDocs[i];
                    if (!stockDoc.exists) throw new Error(`stock ${id} not found`);
    
                    const { stock, cost:productCost, linkMultiply } = stockDoc.data();
                        const oldStock = Number(nanToZero(stock))
                        const newStock = oldStock+diffQty // ไม่เป็น undefied แน่นอน
                        let newCost = Number(productCost)

                        if(id === baseId){
                            updateStock = newStock/linkMultiply
                        }
                     
                        if(newStock >0 && oldStock >0 ){
                            newCost = ((oldStock*newCost)+(diffTotalCost*linkMultiply))/newStock
                        }
                        transaction.update(db.collection("stock").doc(id),{ 
                            cost:newCost, 
                            stock:newStock, 
                            updateTime:firebase.firestore.FieldValue.serverTimestamp()
                        });
                }

            } else { // 100% check
                const stock = Number(nanToZero(productStock))
                updateStock = stock+diffQty // ไม่เป็น undefied แน่นอน
                let updateCost = Number(productCost) // คือสต๊อกยังติดลบอยู่ ใช้ต้นทุนใหม่เลย
                const totalCost = stock*updateCost
                if(updateStock>0){
                    let averageCost = (totalCost +diffTotalCost)/updateStock
                    if(averageCost>0){
                        updateCost = averageCost
                    }
                }
    
                transaction.update(db.collection("stock").doc(id),{
                    cost:updateCost,
                    stock:updateStock,
                    updateTime:firebase.firestore.FieldValue.serverTimestamp()
                });
            }
            
         
            transaction.update(importRef,{ product:newProduct, totalQty, totalCost });
            return `${updateStock} ${unit}`
        })
        
        dispatch(updateNormalInbound({ importId, newProduct, totalQty, totalCost }));
        setCurrent(prev=>({...prev,product:newProduct}))
        if (notiImport && notiImport.length>0) {
            notiImport.forEach(item => {
              const notificationContent = `เลขที่ใบสั่งซื้อ ${billNumber}\nโดย ${profileName}\n${name}\nจำนวน(${prevQty} => ${nextQty})\nต้นทุน(${handleDigit4(prevCost)} => ${handleDigit4(nextCost)})\nคงเหลือ ${remain} `;
              pushByTwoFilter({ id: item, shopId, content: notificationContent, heading: 'ปรับแก้ไข รายการรับสินค้า', data: { screen: 'HomeScreen' } });
            });
        }
        setLoading(false)
    } catch (error) {
        console.log(error)
        setLoading(false)
    } 
};

  return (
    <Modal
      backdrop={backdrop}
      animation={animation}
      show={show}
      onHide={onHide}
      centered={centered}
      size={size}
      fullscreen={true}
    >
        <Modal_Loading show={loading} />
        <Modal_TwoInput
            show={product_Modal}
            onHide={()=>{setProduct_Modal(false)}}
            placeholder="1. จำนวนสินค้า"
            placeholder2="2. ต้นทุนสินค้าต่อหน่วย"
            value={nextQty}
            value2={nextCost}
            onChange={nextQty=>setThisProduct(prev=>({...prev,nextQty}))}
            onChange2={nextCost=>setThisProduct(prev=>({...prev,nextCost}))}
            onClick={submit}
            header='แก้ไขรายการ'
        />
 
        <Modal.Header closeButton>
            <h2><b>ใบรับสินค้า</b></h2>
        </Modal.Header>
        <Modal_Alert
            show={status}
            onHide={()=>{setAlert_Modal(initialAlert)}}
            content={content}
            onClick={onClick}
            variant={variant}
        />
        <Modal.Body style={styles.container} >
          <div>
              <div style={styles.container4} >
                  <h6 style={styles.text7} >เลขที่ใบสั่งซื้อ</h6>
                  <p style={styles.text} >{billNumber} </p>
              </div>
              <div style={styles.container4} >
                  <h6 style={styles.text7} >เวลา</h6>
                  <p style={styles.text} >{stringDateTimeReceipt(dateTime)} </p>
              </div>
              <div style={styles.container4} >
                  <h6 style={styles.text7} >ผู้รับ</h6>
                  <p style={styles.text} >{createName} </p>
              </div>
          </div>
          <br/>
          <div  >
            <h6>ผู้ขาย</h6>
            <div style={styles.container4} >
                  <h6 style={styles.text7} >คู่ค้า</h6>
                  <p style={styles.text} >{vender_Name} </p>
              </div>
              <div style={styles.container4} >
                  <h6 style={styles.text7} >เซลล์</h6>
                  <p style={styles.text} >{sale_Name} </p>
              </div>
              <div style={styles.container4} >
                  <h6 style={styles.text7} >ไลน์</h6>
                  <p style={styles.text} >{lineId} </p>
              </div>
              <div style={styles.container4} >
                  <h6 style={styles.text7} >ติดต่อ</h6>
                  <p style={styles.text} >{tel} </p>
              </div>
          </div>
            <Table striped bordered hover responsive  variant="light"   >
                <thead  >
                <tr>
                <th style={styles.text4}>No.</th>
                <th style={styles.text5}>รายการสินค้า</th>
                <th style={styles.text6}>จำนวน</th>
                <th style={styles.text6}>ต้นทุนต่อหน่วย</th>
                <th style={styles.text6}>ต้นทุนทั้งหมด</th>
                <th style={styles.text6}>วันหมดอายุ</th>
                <th style={styles.text6}>Lot</th>
                <th style={styles.text6}>จัดการ</th>
                </tr>
            </thead>
            <tbody  >
                {product.map(( item, index) => {
                    const { name, qty, cost, exp, lot } = item;
                    return <tr  style={styles.container5} key={index} >
                                <td style={styles.text2}>{index+1}.</td>
                                <td style={styles.text2} >{name}</td>
                                <td style={styles.text2} >{qty}</td>
                                <td style={styles.text2}>{handleDigit4(cost)}</td>
                                <td style={styles.text2}>{handleDigit4(cost*qty)}</td>
                                <td style={styles.text2}>{stringDateTimeReceipt(formatTime(exp))}</td>
                                <td style={styles.text2}>{lot}</td>
                                <td style={styles.text2}>
                                    <OneButton {...{ text:'แก้ไข', variant:'warning', submit:()=>{openProduct(item)} }} />
                                </td>
                            </tr>
                })}
            </tbody>
            </Table>
        </Modal.Body>
        <Modal.Footer>
            <OneButton {...{ text:'ปิด', submit:onHide, variant:'secondary' }} />
        </Modal.Footer>
    </Modal>
  );
};

const styles = {
    container : {
      minHeight:'200px'
    },
    container2 : {
      marginBottom:'2rem'
    },
    container3 : {
      borderTop:`1px solid ${dark}`,padding:10,borderBottom:`1px solid ${dark}`
    },
    container4 : {
      display:'flex',alignItems:'center'
    },
    container5 : {
      cursor: 'pointer'
    },
    container6 : {
      display:'flex',justifyContent:'flex-end'
    },
    container7 : {
      display:'flex',justifyContent:'center'
    },
    container8 : {
      fontFamily: "Sarabun", fontSize:10
    },
    container9 : {
        padding:8,
        marginTop:30
    },
    container10 : {
      flexDirection:'row'
    },
    text: {
      marginBottom:7
    },
    text2 : {
      textAlign:'center'
    },
    text3 : {
      width:'50px'
    },
    text4 : {
      width: '10%', textAlign:'center' 
    },
    text5 : {
      width: '30%', textAlign:'center'
    },
    text6 : {
      width: '20%', textAlign:'center' , minWidth:'120px'
    },
    text7 : {
      width:'150px',
    },
    image : {
      width:'300px'
    }
}
export default Modal_Inbound;
